import React from 'react';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import References from '@/components/References';
import Services from '@/components/Services';
import FamilyStory from '@/components/FamilyStory';
import CurtainWash from '@/components/CurtainWash';
import HouseVisits from '@/components/HouseVisits';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import CookieBanner from '@/components/CookieBanner';

const HomePage = () => (
  <div className="bg-[#F8F5F0]">
    <Navbar />
    <Hero />
    <References />
    <Services />
    <FamilyStory />
    <CurtainWash />
    <HouseVisits />
    <Contact />
    <Footer />
    <CookieBanner />
  </div>
);

export default HomePage;
